import { ApiDataAccess } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { StorageLocation } from '../types/storage-location';
import {
  SOFTLINE_API_STORAGE_LOCATION_LOCATIONS,
  SOFTLINE_API_STORAGE_LOCATION_SCAN,
} from '../storage-location.api';
import { LabelType } from '@softline/application';
import { Observable } from 'rxjs';

@Injectable()
export class StorageLocationRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  getStorageLocation(query: string): Observable<StorageLocation[]> {
    return this.#dataAccess.get$<StorageLocation[]>({
      path: SOFTLINE_API_STORAGE_LOCATION_LOCATIONS,
      queryParams: {
        query,
      },
    });
  }

  async scanLocation(
    type: LabelType | null | undefined,
    code: string
  ): Promise<StorageLocation> {
    return await this.#dataAccess.get<StorageLocation>({
      path: SOFTLINE_API_STORAGE_LOCATION_SCAN,
      queryParams: { type, code },
    });
  }
}
